import { RoleEnum, userStore } from 'stores';
import { hasRole } from './RoleHelper';

function getAllowedUserIds() {
    return (process.env.REACT_APP_AI_PROMPT_ALLOWED_USER_IDS || '')
        .split(',')
        .map((id) => id.trim())
        .filter((id) => id.length > 0);
}

export function canAccessAiPromptAdmin() {
    const signedInUser = userStore.signedInUser;
    if (!signedInUser) return false;
    if (!hasRole(RoleEnum.SUPER_ADMIN)) return false;

    const allowedUserIds = getAllowedUserIds();
    if (allowedUserIds.length === 0) return false;

    return allowedUserIds.includes(signedInUser.id);
}
